import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

import { Match, Player, PlayerResult } from '../../../../database.schema';
import { useFetchPlayers } from '../../../api/hooks/use-fetch-players';

const PlayerWrapper = styled.div<{ bgColor?: string | null }>`
  width: 7rem;
  color: white;
  min-height: 1.5rem;
  margin: 0 0 0.25rem;
  text-align: center;
`;
type DropProps = {
  bgColor: string;
};
const PlayerDropZone = styled.div<DropProps>`
  background-color: ${(props) => props.bgColor};
  width: 7rem;
  border: 1px solid black;
  border-radius: 0.25rem;
  height: 2rem;
  min-height: 1.5rem;
  padding: 0.25rem;
  text-align: center;
`;

const Points = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 0 0.25rem;
`;
const Score = styled.input`
  width: 2rem;
  height: 1.5rem;
  text-align: center;
`;
type MatchPlayerProps = {
  player: PlayerResult;
  bgColor: string;
  team: string;
  playerIndex: number;
  matchIndex: number;
  match: Match;
  onChangePlayerScore: (points: number, playerIndex: number, matchIndex: number, team: string) => void;
};

export const MatchPlayer: FC<MatchPlayerProps> = ({ player, playerIndex, bgColor, team, matchIndex, match, onChangePlayerScore }): JSX.Element => {
  const [points, setPoints] = useState<number | string>(player.points);
  const [playerData, setPlayerData] = useState<Player>();
  const { data } = useFetchPlayers();
  const players = data as Array<Player>;
  useEffect(() => {
    if (players) {
      const foundPlayer = players.find((playerA: Player) => playerA.id === player.playerId);
      if (foundPlayer) {
        setPlayerData(foundPlayer);
      }
    }
  }, [players, player.playerId]);

  const updatePoints = (points: string) => {
    setPoints(points);
    if (Number(points)) {
      onChangePlayerScore(Number(points), playerIndex, matchIndex, team);
    }
  };
  return (
    <div>
      <PlayerWrapper bgColor={bgColor} data-testid={`${team}-player-${matchIndex}`}>
        <PlayerDropZone bgColor={bgColor}>
          {playerData ? (
            <div>
              {playerData.nickName} <input name={`${team}-player-${matchIndex}`} type="hidden" readOnly value={player?.playerId} />
            </div>
          ) : null}
        </PlayerDropZone>
      </PlayerWrapper>
      {playerData ? (
        <Points>
          Points:
          <Score
            type="text"
            name={`${team}-player-score-${matchIndex}`}
            data-testid={`${team}-player-${playerIndex}-score-${matchIndex}`}
            value={points === 0 ? '' : points}
            onChange={(event) => updatePoints(event.target.value)}
          />
        </Points>
      ) : null}
    </div>
  );
};
